import { bus, Message } from '@skinsoft/bus';
import { empty, merge, Observable, of, PartialObserver } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import VueI18n from 'vue-i18n';
import { Vue } from 'vue-property-decorator';

import { SubscriptionPool } from './subscription-pool';
import { SyncQueue } from './sync-queue';

export class ReactiveVue extends Vue {
    public $i18n: VueI18n;
    protected pool = new SubscriptionPool();
    protected syncQueue$ = new SyncQueue();

    public beforeDestroy() {
        this.pool.flush();
    }

    protected emitOnBus(topic: string, payload?: any) {
        bus.emit(topic, payload);
    }

    protected subscribeToSyncQueue(observer: () => any | PartialObserver<void>) {
        if (!this.syncQueue$.started) {
            this.pool.add(this.syncQueue$.start());
        }

        return this.subscribeTo(this.syncQueue$, observer);
    }

    protected triggerSync() {
        this.syncQueue$.tick();
    }

    protected subscribeToBus(
        topic: string,
        observer: (value: Message) => any | PartialObserver<Message>,
    ) {
        return this.subscribeTo(bus.listen$(topic), observer);
    }

    protected subscribeTo<T = any>(
        source$: Observable<T>,
        observer: (value: T) => any | PartialObserver<T>,
        name?: string,
        notify$?: Observable<T>,
    ) {
        const subscription = merge(of(true), notify$ || empty())
            .pipe(switchMap(() => source$))
            .subscribe(observer);
        this.pool.add(subscription, name);

        return subscription;
    }

    protected unsubscribeFrom(name: string) {
        const subscription = this.pool.get(name);

        if (subscription) {
            subscription.unsubscribe();
        }
    }

    protected waitForUserApproval(message) {
        if (!window.confirm(message)) {
            throw new Error('User denied approval');
        }
    }
}
